import React, { Component } from 'react';
import {connect} from 'react-redux';
import {login} from '../../../config/redux/actions/securityActions';
import { GetLogin2,GetUserPermissions} from '../../../services/SecurityService';
import CardLogin from '../../components/CardLogin';
import COLORS from '../../resources/colors/ColorsApp';

class LoginPages extends Component {
    constructor(props){
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(email, password, afterSubmit){
      
let data = {username: email , password : password, consulta : 1}


                GetLogin2(data)
                .then(userData2 => {
                 if(userData2!="No existen clientes en la BBDD." && userData2!='{"error" : {"text":SQLSTATE[HY000] [2006] MySQL server has gone away}' && userData2!="error en el servidor." ){console.log("Si se pudo xD")
             console.log(userData2)}
                if(userData2=="No existen clientes en la BBDD." || userData2=='{"error" : {"text":SQLSTATE[HY000] [2006] MySQL server has gone away}' || userData2=="error en el servidor."){
                    console.log("No pues ya valio");
                    alert("Usuario Y/O Contraseña Incorrectos")
                    return window.location.reload();;
                } 

                        const securityState = {
                            IdUsuario: Number(userData2[0].idtipousuario),
                            Usuario: userData2[0].username,
                            Correo: userData2.token,
                            PersonData: userData2[0].home,
                            iduser:userData2[0].id_usuario,
                            tipo:userData2[0].tipo,
                            id_usuario:userData2[0].id
                        
                        };
                        this.props.login(securityState, null);
                        console.log("segun ya estufas T_T")
                        sessionStorage.setItem('security', JSON.stringify(securityState));
                        afterSubmit();
                    

            }).catch(err => {
                afterSubmit();
            });



           
   
    }

    render() {    
        return (
            <div style={styles.mainContainer}>

            {
             //   <img src={require("../../resources/images/tec-logo.png")} height={140} width={431}/>
        }
                <CardLogin onSubmit={this.handleSubmit}/>
                
            </div>
        );
    }
}

const styles = {
    mainContainer: {
        height: '100vh',
        backgroundImage: "url("  + ")",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    }
};

const mapStateToProps = (state, props) => {
    return {
      users: state.security,
    };
}
const mapDispatchToProps = {
    login
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginPages)